import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "../../firebase";

const isDuplicatePhoneNumber = async (authProviderPhone) => {
  /**
   * input:
   *  authProvider: email | phone
   * output: bool
   * description: checks if phone number exists
   */

  try {
    const leadsCollection = await collection(db, "leads");
    const q = query(
      leadsCollection,
      where("phone", "==", authProviderPhone),
      where("is_deleted", "==", false)
    );
    const leadSnapshot = await getDocs(q);
    return leadSnapshot.docs.length === 0 ? false : true;
  } catch (error) {
    console.log(error);
    return false;
  }
};

export default isDuplicatePhoneNumber;
